import { useState } from 'react';
import MDBox from 'src/components/md/MDBox';
import Modal from 'src/components/modal/Modal';
import { TextField, SelectChangeEvent } from '@mui/material';
import useCreateCategory from 'src/api/inventory-management/useCreateCategory';

const CreateCategoryModal: React.FC<{
  onClose: (refetch?: boolean) => void;
}> = ({ onClose }) => {
  const {
    mutate: createCategory,
    isLoading,
    error,
  } = useCreateCategory(() => {
    onClose(true);
  });
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    // parentCategoryId: '', // TODO implement
  });

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal
      open={true}
      title="Create Category"
      closeable
      isLoading={isLoading}
      onConfirmButton={{
        text: 'Create',
        onClick: () => {
          createCategory(formData);
        },
        disabled: isLoading,
      }}
      onCloseButton={{ text: 'Cancel', onClick: onClose }}
      error={error}
    >
      <MDBox>
        <MDBox display="flex" flexDirection="column" gap={2} mt={2}>
          <TextField
            name="name"
            label="Name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            name="description"
            label="Description"
            value={formData.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
          />
        </MDBox>
      </MDBox>
    </Modal>
  );
};

export default CreateCategoryModal;
